import apiClient from './apiClient';

export interface Ticker {
  id: number;
  ticker: string;
  name: string | null;
  sector: string | null;
  liquidity_tier: number;
  active: boolean;
  added_at: string;
  added_by?: string | null;
  added_by_email?: string | null;
  added_by_name?: string | null;
}

export interface TickerPage {
  items: Ticker[];
  total: number;
  page: number;
  page_size: number;
}

export const adminService = {
  listTickers: (page = 1, pageSize = 50) =>
    apiClient.get<TickerPage>('/api/admin/tickers', { params: { page, page_size: pageSize } }).then((r) => r.data),

  addTickers: (tickers: string) =>
    apiClient.post<Ticker[]>('/api/admin/tickers', { tickers }).then((r) => r.data),

  removeTicker: (ticker: string) =>
    apiClient.delete(`/api/admin/tickers/${ticker}`),

  updateTicker: (ticker: string, data: Partial<Ticker>) =>
    apiClient.patch<Ticker>(`/api/admin/tickers/${ticker}`, data).then((r) => r.data),

  runJob: (job: 'option-chain' | 'max-pain' | 'earnings-calendar' | 'market-pulse') =>
    apiClient.post(`/api/admin/jobs/${job}`).then((r) => r.data),

  runEarningsAnalyzer: (forDate?: string) =>
    apiClient.post(`/api/admin/jobs/earnings-analyzer${forDate ? `?for_date=${forDate}` : ''}`).then((r) => r.data),

  getConfig: (key: string) =>
    apiClient.get<{ key: string; value: string; description: string }>(`/api/admin/config/${key}`).then((r) => r.data),

  setConfig: (key: string, value: string) =>
    apiClient.put(`/api/admin/config/${key}`, { value }).then((r) => r.data),

  maxPainPreview: (ticker: string, expiry: string, deltaThreshold: number) =>
    apiClient.post<{
      ticker: string;
      expiry: string;
      max_pain: number | null;
      total_pain: number | null;
      strikes_used: number;
      delta_threshold: number;
    }>('/api/admin/max-pain-preview', { ticker, expiry, delta_threshold: deltaThreshold }).then((r) => r.data),

  backfillPaperTrade: (payload: Record<string, any>) =>
    apiClient.post<{ id: number }>('/api/admin/paper-trades/backfill', payload).then((r) => r.data),

  runPaperTradeJob: (jobId: string) =>
    apiClient.post(`/api/admin/jobs/${jobId}`).then((r) => r.data),

  // Terms & Conditions
  listTerms: () =>
    apiClient.get<any[]>('/api/admin/terms').then((r) => r.data),

  createTerms: (payload: { version: string; title: string; body: string; is_active: boolean; require_reaccept: boolean }) =>
    apiClient.post('/api/admin/terms', payload).then((r) => r.data),

  updateTerms: (id: number, payload: Record<string, any>) =>
    apiClient.patch(`/api/admin/terms/${id}`, payload).then((r) => r.data),
};
